import { render, staticRenderFns } from "./Regras.vue?vue&type=template&id=367af93a&scoped=true&lang=pug&"
import script from "./Regras.vue?vue&type=script&lang=js&"
export * from "./Regras.vue?vue&type=script&lang=js&"
import style0 from "./Regras.vue?vue&type=style&index=0&id=367af93a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367af93a",
  null
  
)

export default component.exports